import axios from 'axios';

const BASE_URL = 'https://pbinend.vercel.app';

export const fetchTabContent = (id) => {
    return axios.get(`${BASE_URL}/getPost/${id}`)
        .then((response) => response.data.tabContent)
        .catch((error) => {
            console.error('Error fetching tab details:', error);
            throw error;
        });
};

export const postTabContent = (tabContent) => {
    return axios.post(`${BASE_URL}/addPost`, { tabContent })
        .then((response) => response.data.uniqueID)
        .catch((error) => {
            console.error('Error posting tab details:', error);
            return null;
        });
};
